export var GruserType = /*#__PURE__*/ function(GruserType) {
    GruserType[GruserType["Deviation"] = 1] = "Deviation";
    GruserType[GruserType["Profile"] = 4] = "Profile";
    return GruserType;
}({});

//# sourceMappingURL=index.js.map